import EventList from '@/components/Event/EventList';
import { EventListItemProps } from '@/components/Event/EventListItem';
import DetailCard from '@/components/Module/DetailCard';
import Divider from '@/components/Module/Divider';
import useViewport from '@/hooks/useViewport';

export type VenueDetailProps = {
  imageUrl: string;
  name: string;
  address: string;
  websiteUrl?: string;
  facebookUrl?: string;
  instagramUrl?: string;
  events: EventListItemProps[];
};

const MobileVenueDetail = (props: VenueDetailProps) => {
  const {
    imageUrl,
    name,
    address,
    websiteUrl,
    facebookUrl,
    instagramUrl,
    events,
  } = props;

  return (
    <DetailCard
      type={`Venue`}
      name={name}
      address={address}
      imageUrl={imageUrl}
      instagramUrl={instagramUrl}
      websiteUrl={websiteUrl}
      facebookUrl={facebookUrl}
    >
      <Divider my={56} />
      <EventList events={events} />
    </DetailCard>
  );
};

const DesktopVenueDetail = (props: VenueDetailProps) => {
  const {
    imageUrl,
    name,
    address,
    websiteUrl,
    facebookUrl,
    instagramUrl,
    events,
  } = props;

  return (
    <DetailCard
      type={`Venue`}
      name={name}
      address={address}
      imageUrl={imageUrl}
      instagramUrl={instagramUrl}
      websiteUrl={websiteUrl}
      facebookUrl={facebookUrl}
    >
      <Divider my={79} />
      <EventList events={events} />
    </DetailCard>
  );
};

const VenueDetail = (props: VenueDetailProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileVenueDetail {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopVenueDetail {...props} />;
  }

  return null;
};

export default VenueDetail;
